<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>LaTeX 문법 검사기</h1>
                        <h2>LaTeX 파일용 AI 문법<br class="d-lg-block d-none"/> 검사</h2>
                        <p>플러그인을 설치하는 번거로움을 피하고 LaTeX 파일 자동 문법 검사로 시간을 절약해 보세요.  변경 사항 추적으로 교정 파일을 다운로드하고 문서를 빠르게 마무리할 수 있습니다. 
                        </p>
                        <a href="https://cloud.trinka.ai/signup?_rg=GB" id="autoEditGetStart" target="_blank">시작하기</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../../assets/images/Latex-banner.jpg" alt="Latex Banner">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="how_it_work_section" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>How It Works</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/RegisterAndLogin.png" alt="register">
                                </div>
                                <h3>Register / Login</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt=import"">
                                </div>
                                <h3>Select auto file edit <br />& upload your file</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="download">
                                </div>
                                <h3>Download file with<br /> track changes </h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="../../../../assets/images/latexThumbnail.jpg" alt="latex thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>사용 방법</h2>
                        <div class="HeadingSubLine"></div>
                        <!-- <p style="margin-bottom: 10px;">Trinka LaTeX 문법 검사기를 시작하기 위한 간단한 안내 동영상을 확인하십시오.</p>
                        <p style="margin-bottom: 10px;">Trinka를 최대한 활용할 수 있게 도와주는 상세한 단계별 사용지침서입니다.</p>
                        <p>질문이 더 있습니까? 여기에서 자주 묻는 질문을 <a style="color: #0000ff;" (click)="scroll(target)" class="link">살펴보십시오</a>.</p> -->
                        <p>트링카(Trinka) LaTeX 문법 검사 활용 방법을 상세하게 단계별로 영상을 통해 확인해 보실 수 있습니다.  사용 관련 자주하는 질문은 <a style="color: #0000ff;" (click)="scroll(target)" class="link">여기</a>서 확인해 보세요. </p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>LaTeX 문법 검사의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>LaTeX 파일용 트링카 문법 및 맞춤법 검사의 주요 특징들을 살펴보세요. 
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="icon">
                        <h3>변경 사항 검토</h3>
                        <p>교정된 LaTeX 파일과 함께 검토 및 마무리할 수 있는 변경사항 추적이 포함된 MS Word 파일을 가져옵니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/RetainOriginalFormatting.png" alt="icon">
                        <h3>원본 포맷팅 유지</h3>
                        <p>파일의 원래 형태는 변경하지 않고 텍스트 내용만 업데이트됩니다. 코드 및 태그 또한 변경되지 않습니다.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/languageScore_icon.svg" alt="icon">
                        <h3>언어 점수</h3>
                        <p>문법 카테고리의 수정 횟수를 기준으로 문서의 전반적인 언어 품질에 대한 지표를 나타내는 점수를 확인할 수 있습니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/TableofRevisions_icon.svg" alt="icon">
                        <h3>테이블 수정</h3>
                        <p>카테고리별 언어 수정 사항에 대한 자세한 표를 확인해 수정 유형을 빠르게 파악할 수 있습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="icon">
                        <h3>스타일 가이드 기본 설정</h3>
                        <p>학술지 스타일 가이드(APA, AMA, AGU, ACS, IEEE)에 맞게 원고의 문법과 단어 선택을 맞춤화 합니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="icon">
                        <h3>개인 설정 옵션</h3>
                        <p>트링카를 사용자 지정하여 주제에 따라 가장 관련성이 높은 영역을 제안 합니다.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="uploadOptionSection">
        <div class="container">
            <div class="uploadContentSection">
                <h2>즐겨 사용하는 클라우드 스토리지에서 파일을 
                    가져와서 짧은시간 안에 편집해 보세요!</h2>
                <ul>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="44" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.6349 15.109C21.6349 15.3108 21.5751 15.5081 21.4629 15.676C21.3508 15.8438 21.1914 15.9746 21.0049 16.0518C20.8184 16.1291 20.6132 16.1493 20.4152 16.1099C20.2173 16.0705 20.0354 15.9733 19.8927 15.8306C19.7499 15.6879 19.6527 15.506 19.6134 15.3081C19.574 15.1101 19.5942 14.9049 19.6714 14.7184C19.7487 14.5319 19.8795 14.3725 20.0473 14.2604C20.2152 14.1482 20.4125 14.0884 20.6143 14.0884C20.885 14.0884 21.1446 14.1959 21.336 14.3873C21.5274 14.5787 21.6349 14.8383 21.6349 15.109V15.109Z" fill="#773795"/>
                                <path d="M24.9945 10.7444C24.9945 10.5326 25.3093 11.3578 21.1944 1.46144C21.1374 1.32431 21.0409 1.20723 20.9172 1.12507C20.7934 1.04291 20.6481 0.999383 20.4996 1.00001H6.24404C6.10455 0.999291 5.96763 1.03753 5.8487 1.11042C5.72977 1.18332 5.63356 1.28796 5.57089 1.41258C0.685141 11.1841 1.02171 10.4729 1 10.6412C1 10.7118 1 10.1961 1 18.2413C1 18.3397 1.01938 18.4371 1.05703 18.528C1.09467 18.6188 1.14986 18.7014 1.21942 18.771C1.28899 18.8406 1.37157 18.8957 1.46246 18.9334C1.55335 18.971 1.65077 18.9904 1.74915 18.9904H24.2453C24.4421 18.9904 24.631 18.913 24.7712 18.7748C24.9114 18.6367 24.9916 18.4489 24.9945 18.2521C24.9945 18.1273 24.9945 10.7986 24.9945 10.7444V10.7444ZM24.9945 10.6901H1.02171H24.9945Z" stroke="#4D4D4D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>Trinka My Drive</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="52" height="46" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.25 0C3.65326 0 3.08097 0.237053 2.65901 0.65901C2.23705 1.08097 2 1.65326 2 2.25V11.25C2 11.8467 2.23705 12.419 2.65901 12.841C3.08097 13.2629 3.65326 13.5 4.25 13.5H19.75C20.3467 13.5 20.919 13.2629 21.341 12.841C21.7629 12.419 22 11.8467 22 11.25V2.25C22 1.65326 21.7629 1.08097 21.341 0.65901C20.919 0.237053 20.3467 0 19.75 0H4.25ZM3.5 2.25C3.5 2.05109 3.57902 1.86032 3.71967 1.71967C3.86032 1.57902 4.05109 1.5 4.25 1.5H19.75C19.9489 1.5 20.1397 1.57902 20.2803 1.71967C20.421 1.86032 20.5 2.05109 20.5 2.25V11.25C20.5 11.4489 20.421 11.6397 20.2803 11.7803C20.1397 11.921 19.9489 12 19.75 12H4.25C4.05109 12 3.86032 11.921 3.71967 11.7803C3.57902 11.6397 3.5 11.4489 3.5 11.25V2.25ZM0.75 14.5C0.551088 14.5 0.360322 14.579 0.21967 14.7197C0.0790175 14.8603 0 15.0511 0 15.25C0 15.4489 0.0790175 15.6397 0.21967 15.7803C0.360322 15.921 0.551088 16 0.75 16H23.25C23.4489 16 23.6397 15.921 23.7803 15.7803C23.921 15.6397 24 15.4489 24 15.25C24 15.0511 23.921 14.8603 23.7803 14.7197C23.6397 14.579 23.4489 14.5 23.25 14.5H0.75Z" fill="#4D4D4D"/>
                                <path d="M10 6H14" stroke="#773795" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>내 장치</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="51" height="47" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8871)">
                                <path d="M5.99953 0L0 3.82228L5.99953 7.64466L12 3.82228L5.99953 0ZM18 0L12 3.82266L18 7.64531L24.0001 3.82266L18 0ZM0 11.4676L5.99953 15.29L12 11.4676L5.99953 7.64531L0 11.4676ZM18 7.64531L12 11.468L18 15.2905L24 11.468L18 7.64531ZM6 16.5723L12.0005 20.3947L18 16.5723L12.0005 12.75L6 16.5723Z" fill="#0061FF"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8871">
                                <rect width="24" height="20.4375" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >DropBox</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="46" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81444 18.3783L2.87287 20.2064C3.09281 20.5914 3.40894 20.8938 3.78009 21.1137C4.84322 19.7643 5.58309 18.7287 6.00009 18.0071C6.42319 17.2749 6.94322 16.1293 7.56019 14.5707C5.89744 14.3518 4.63744 14.2424 3.78019 14.2424C2.95734 14.2424 1.69734 14.3518 0 14.5707C0 14.9968 0.109969 15.4229 0.329906 15.8079L1.81444 18.3783V18.3783Z" fill="#0066DA"/>
                                <path d="M20.2204 21.1137C20.5917 20.8938 20.9078 20.5914 21.1276 20.2065L21.5675 19.4505L23.6707 15.8079C23.8866 15.4313 24.0003 15.0048 24.0005 14.5707C22.2933 14.3518 21.0357 14.2424 20.2274 14.2424C19.3587 14.2424 18.1009 14.3518 16.4541 14.5707C17.0638 16.1379 17.5769 17.2834 17.9937 18.0071C18.4139 18.7374 19.1562 19.7728 20.2204 21.1137V21.1137Z" fill="#EA4335"/>
                                <path d="M11.9998 6.87291C13.2298 5.38744 14.0775 4.24191 14.5428 3.4365C14.9175 2.78794 15.3299 1.75238 15.7799 0.329906C15.4088 0.109969 14.9827 0 14.5428 0H9.45685C9.01698 0 8.59098 0.12375 8.21973 0.329906C8.79216 1.96134 9.27798 3.12244 9.67698 3.81309C10.118 4.57641 10.8923 5.59631 11.9998 6.87291Z" fill="#00832D"/>
                                <path d="M16.4401 14.5706H7.56028L3.78027 21.1136C4.15134 21.3335 4.57743 21.4435 5.01731 21.4435H18.9831C19.4229 21.4435 19.8491 21.3197 20.2202 21.1135L16.4402 14.5706H16.4401Z" fill="#2684FC"/>
                                <path d="M12.0001 6.87298L8.22009 0.330078C7.84884 0.550016 7.53272 0.852359 7.31278 1.2373L0.329906 13.3336C0.114012 13.7102 0.000285232 14.1366 0 14.5707H7.56019L12.0002 6.87298H12.0001Z" fill="#00AC47"/>
                                <path d="M20.1788 7.28524L16.6872 1.23705C16.4674 0.852115 16.1512 0.549772 15.78 0.329834L12 6.87284L16.4398 14.5706H23.9863C23.9863 14.1444 23.8763 13.7184 23.6564 13.3334L20.1788 7.28524Z" fill="#FFBA00"/>
                            </svg>
                        </div>
                        <p >Google Drive</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>샘플 보기</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="viewSampleReportImg">
                        <img src="../../../../assets/images/latex-sample-report.svg" alt="sample report">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>LatTeX 파일의 언어 품질을 지금 향상시켜 보세요!</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank">시작하기</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>LaTeX 문법 검사에 크레딧 사용</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        <div class="featurePointsCredits">
                            <span>
                                <img src="../../../assets/images/credits_icon.png" alt="icon">
                            </span>
                            <p>파일의 5000단어 당 1크레딧을 사용합니다. 무료 크레딧을 사용하고 필요에 따라 더 구입하실 수 있습니다..</p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 10px;">크레딧은 필요에 따라 트링카 Trinka 기능을 사용할 수 있는 토큰과 같습니다.</p>
                            <p>매월 프리미엄 사용자에게는 10 크레딧, 베이직 사용자에게는 4 크레딧이 무료로 제공됩니다. 자세한 사항은 <a href="https://trinka.ai/features/credits" target="_blank">여기</a>를 클릭해 주세요.</p>
                            
                        </div>
                    </div>
                </div>
                
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Free Credits Available</h3>
                        </div>
                        <p>Basic users get 2 and Premium users get 5 free credits every month. Unused free credits expire at month end.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Credits Consumed</h3>
                        </div>
                        <p>Auto File Edit uses 1 credit for every 5000 words. You may upload larger files; credits required will be shown and consumed accordingly. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Buy More Credits</h3>
                        </div>
                        <p>If you need additional credits, you can purchase them whenever needed. Purchased Credits do not expire.</p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>자무 묻는 질문</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka LaTeX 문법 검사기는 어떻게 작동합니까? </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>LaTeX 파일을 업로드하면 업로드된 문서가 처리되고 AI가 제안한 수정 사항이 적용됩니다. 변경 사항이 적용된 원본 LaTeX 파일은 물론 MS Word의 '변경 사항 추적' 기능을 사용해 변경된 모든 내용이 표시된 MS Word 파일도 받을 수 있습니다.
                                        </p>
                                        <p>또한 수정 횟수, 문법 오류 유형, 전반적인 글쓰기 품질 점수에 대한 자세한 정보도 확인할 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        교정 기능을 무료로 사용해 볼 수 있습니까?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>예. Trinka의 기본 계정에 가입하면 무료로 4 크레딧을 받습니다. 이 크레딧을 사용해 LaTeX 파일에 대한 문법 검사를 무료로 할 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        교정 파일 사용 시 얼마나 많은 크레딧이 소모됩니까?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>교정 파일에는 파일의 단어 5000개당 1크레딧을 사용합니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Trinka Proofread를 사용해 Overleaf에서 LaTeX 파일을 편집할 수 있습니까?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>아니오. Trinka는 Overleaf와 직접 통합돼 있지 않지만, Overleaf에서 최종 파일을 업로드하고 몇 분 안에 Trinka로 
                                            교정을 받을 수 있습니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Trinka 교정 파일은 LaTeX용 언어 도구와 어떻게 다릅니까? 
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka Proofread는 자동 교정기인 반면, LaTeX용 언어 도구에서는 제안 항목을 수동으로 선택해야 합니다. Trinka는 
                                            특히 LaTeX 문법 검사에 맞춰져 있으며 학계 및 기술 작가에게 이상적으로 적합합니다.
                                            
                                            </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서 Trinka 사용하기</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/wordplugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="trinka ms word">
                                            <h3>MS Word 추가 기능</h3>
                                        </div>
                                </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon">
                                            <h3>Browser Plug-In</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/enterprise']">
                                        <div class="app_name_content" style="padding: 0px;">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="icon">
                                            <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                        </div>
                                    </a>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/joaE-2djPGE"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>